/* TMSS dark homepage: carousel arrows + scroll reveals. */
(function () {
  'use strict';

  function init() {
    // carousel arrows
    document.querySelectorAll('.tmss-carousel-shell').forEach(function (shell) {
      var track = shell.querySelector('.tmss-carousel');
      if (!track) return;
      shell.querySelectorAll('.tmss-car-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.querySelector('.tmss-car-item');
          var step = (card ? card.getBoundingClientRect().width : 600) + 20;
          track.scrollBy({ left: step * Number(btn.dataset.dir || 1), behavior: 'smooth' });
        });
      });
    });

    // scroll reveal
    var reveals = document.querySelectorAll('.tmss-reveal');
    if (!reveals.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // re-init when Shopify theme editor re-renders a section
  document.addEventListener('shopify:section:load', init);
})();

/* Live YouTube subscriber count for hero stats. */
(function () {
  'use strict';
  function fmt(n) {
    return new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(n).replace('.0', '');
  }
  function initYT() {
    var el = document.querySelector('[data-tmss-yt-stat]');
    if (!el || el.dataset.done) return;
    el.dataset.done = '1';
    var key = el.dataset.ytKey, ch = el.dataset.ytChannel;
    var qs = ch.indexOf('@') === 0 ? 'forHandle=' + encodeURIComponent(ch) : 'id=' + encodeURIComponent(ch);
    fetch('https://www.googleapis.com/youtube/v3/channels?part=statistics&' + qs + '&key=' + encodeURIComponent(key))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.items && d.items[0] && d.items[0].statistics && d.items[0].statistics.subscriberCount;
        if (c) el.textContent = fmt(Number(c));
      })
      .catch(function () { /* keep the manual value */ });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initYT);
  } else { initYT(); }
  document.addEventListener('shopify:section:load', initYT);
})();
